import BaseActions from './_base_actions';
import { store } from '../store';
import Rest from '../webapi/Rest';
import { AppConstants } from '../constants/AppConstants';
import DOMAINS from '../constants/Domini';

const EnumActions = Object.freeze({
    WINDOW_WIDTH_CHANGED: 'WINDOW_WIDTH_CHANGED',
    NOTIFY_MESSAGE_ADD: 'NOTIFY_MESSAGE_ADD',
    NOTIFY_MESSAGE_DELETE: 'NOTIFY_MESSAGE_DELETE',
    NOTIFY_MESSAGE_CLEAR: 'NOTIFY_MESSAGE_CLEAR',
    LOADER_SHOW: 'LOADER_SHOW',
    LOADER_HIDE: 'LOADER_HIDE',
    LOADER_USER_SHOW: 'LOADER_USER_SHOW',
    LOADER_USER_HIDE: 'LOADER_USER_HIDE',
    LOAD_DOMINI: 'LOAD_DOMINI_APP',
    LOAD_I18N: 'LOAD_I18N',
    SHOW_POPOUP: 'SHOW_POPOUP',
    VERSION_INFO: 'VERSION_INFO',
    DEBUG: 'DEBUG',
    LOAD_OPZIONI: 'LOAD_OPZIONI',
    ADD_I18N: 'ADD_I18N',
    LOCATE_CHANGE: 'LOCATE_CHANGE',
    CHANGE_URL: 'CHANGE_URL',

});

module.exports.EnumAppActions = EnumActions;


const EnumDeviceSize = Object.freeze({
    EXTRA_SMALL: 'EXTRA_SMALL',
    SMALL: 'SMALL',
    MEDIUM: 'MEDIUM',
    LARGE: 'LARGE'
});

const EnumNotifyType = Object.freeze({
    Success: 'SUCCESS',
    Info: 'INFO',
    Warning: 'WARNING',
    Danger: 'DANGER'
});

module.exports.EnumDeviceSize = EnumDeviceSize;

class AppActions extends BaseActions {

    constructor() {
        super();

        this.moduleName = "[AccountActions] ";
        console.log(this.moduleName + "constructor");
    }

    get Actions() {
        return EnumActions;
    }

    addNotify(tipo, messaggio) {
        return function(dispatch) {
            let id = new Date().getTime();
            console.log("[AppActions] addNotify id: " + id);
            dispatch({ type: EnumActions.NOTIFY_MESSAGE_ADD, message: messaggio, messageType: tipo, messageId: id });

            if (tipo === EnumNotifyType.Success) {
                window.setTimeout(() => {
                    dispatch({ type: EnumActions.NOTIFY_MESSAGE_DELETE, messageId: id });
                }, 4000);
            }

        }
    }

    deleteNotify(id) {
        //console.log("[AppActions] delete Notify ");
        return { type: EnumActions.NOTIFY_MESSAGE_DELETE, messageId: id };
    }

    clearNotify() {
        console.log("[AppActions] clear Notify ");
        return { type: EnumActions.NOTIFY_MESSAGE_CLEAR }
    }

    checkDeviceSize(width) {
        console.log("[AppActions] checkDeviceSize: " + width);
        let deviceSize;

        if (width < 768) {
            //BaseDispatcher.dispatch({ type: EnumActions.WINDOW_WIDTH_CHANGED, response: EnumDeviceSize.EXTRA_SMALL });
            deviceSize = EnumDeviceSize.EXTRA_SMALL;
        } else if (width >= 768 && width < 992) {
            //BaseDispatcher.dispatch({ type: EnumActions.WINDOW_WIDTH_CHANGED, response: EnumDeviceSize.SMALL });
            deviceSize = EnumDeviceSize.SMALL;
        } else if (width >= 992 && width < 1200) {
            //BaseDispatcher.dispatch({ type: EnumActions.WINDOW_WIDTH_CHANGED, response: EnumDeviceSize.MEDIUM });
            deviceSize = EnumDeviceSize.MEDIUM;
        } else {
            //BaseDispatcher.dispatch({ type: EnumActions.WINDOW_WIDTH_CHANGED, response: EnumDeviceSize.LARGE });
            deviceSize = EnumDeviceSize.LARGE;
        }

        return {
            type: EnumActions.WINDOW_WIDTH_CHANGED,
            deviceSize: deviceSize
        }

    }

    loadDomains(domainCodes) {
        console.log(this.moduleName + "loadDomains: " + domainCodes);

        return function(dispatch) {
            let domini = store.getState().app.domini;
            if (!domainCodes) {
                domainCodes = {};
            }

            //filtro i domini da caricare
            domainCodes = domainCodes.filter(item => {
                return !domini[item];
            });


            console.log("loadDomains dopo filtro: " + domainCodes);
            if (domainCodes.length === 0) {
                return Promise.resolve();
            }

            return Rest.post('domini/load', domainCodes, dispatch).then(
                resolve => {
                    console.warn("LOAD DOMAINS DONE");
                    dispatch({
                        type: EnumActions.LOAD_DOMINI,
                        domini: resolve || []
                    });
                    return resolve
                });
            // }
        }
    }

    loadI18nLabels(filter, lang) {
        console.log("[AppActions] loadI18nLabels: " + lang);
        return function(dispatch) {
            let i18n = new Object();
            i18n.listCodes = filter;
            i18n.codLang = lang;
			// return Rest.post('i18n/load', i18n, null
            return Rest.post('i18n/load', i18n, null).then(
                resolve => {
                    console.warn("LOAD I18N DONE");
                    dispatch({ type: EnumActions.LOAD_I18N, i18nlabels: resolve });
                    dispatch({ type: EnumActions.LOCATE_CHANGE, locate: lang });
                    return resolve;
                });
        }
    }

    pushI18nLabel(key, value) {
        return function(dispatch, getState) {


            let i18nlabels = getState().app.i18nlabels;

            i18nlabels[key] = value;


            dispatch({ type: EnumActions.ADD_I18N, i18nToSave: i18nlabels });

        }
    }

    getVersionInfo() {
        return function(dispatch) {
            return Rest.get('mcr/authentication/info', null, dispatch).then(
                resolve => {
                    dispatch({ type: EnumActions.VERSION_INFO, versionInformation: resolve });
                    return resolve
                }, reject => {
                    return reject;
                });
        }
    }
    getDebug() {
        return function(dispatch) {
            return Rest.get('mcr/authentication/debug', null, dispatch).then(
                resolve => {
                    dispatch({ type: EnumActions.DEBUG, debugObj: resolve });
                    return resolve
                }, reject => {
                    return reject;
                });
        }
    }


    changeLocate(lang, user) {
        console.log("changeLocate: " + lang + " user: " + user);
        return dispatch => {

            return Promise.all([
                dispatch({
                    type: EnumActions.LOCATE_CHANGE,
                    locate: lang
                }),
                dispatch(this.loadI18nLabels(AppConstants.I18N_CODES, lang)),
            ]);



        }
    }

    changeURL(url) {
        //console.log("[AppActions] hide Loader  ");
        return function(dispatch) {
            console.log("[AppActions] changeURL: " + url);
            dispatch({ type: EnumActions.CHANGE_URL, url: url });
            return Promise.resolve();
        }
    }

    showPopUp(isShow) {
        return function(dispatch) {
            console.log("[AppActions]  showPopUP [isShow] " + isShow);
            let updateVisModal = { showPopUp: { $set: isShow } }
            dispatch({ type: EnumActions.SHOW_POPOUP, showPopUp: updateVisModal });
        }
    }


    loadOpzioni(opzioniCodes) {
        return function(dispatch, getState) {
            let opzioni = getState().app.opzioni;
            if (!opzioniCodes)
                opzioniCodes = {};

            // Non ricarico le opzioni eventualmente giÃ  esistenti
            opzioniCodes = opzioniCodes.filter(item => {
                return !opzioni[item];
            });

            console.log("load opzioni:  ", opzioniCodes);

            return Rest.post('opzioni/load', opzioniCodes, dispatch).then(
                resolve => {
                    console.warn("LOAD OPZIONI DONE");
                    dispatch({
                        type: EnumActions.LOAD_OPZIONI,
                        opzioni: resolve || [],
                    });
                    return resolve
                });

        }
    }


    saveI18Nlabels() {
        let that = this;
        return function(dispatch, getState) {

            let pojo = {};

            let listApLang = getState().app.i18nlabels;
            pojo.codLang = getState().app.locate;

            let i18nToSave = [];



            for (let [key, value] of Object.entries(listApLang)) {
                console.log(key + " = " + value);

                let input = { code: key, codLang: getState().app.locate, descr: value };
                i18nToSave.push(input);

            }


            pojo.listApLang = i18nToSave;


            return Rest.post('i18n/push', pojo, dispatch).then(
                resolve => {
                    console.log("Tutte le label aggiunte");
                    // that.addNotify('SUCCESS', 'Le label sono aggiunte con successo')
                    dispatch(that.addNotify('SUCCESS', 'Le label sono aggiunte con successo'));
                    // dispatch({ type: EnumActions.UPDATE_I18N, result: resolve });
                },
                reject => {
                    return reject
                }
            )
        }
    }

    download(documentId) {
        console.log("[AppActions]  download [documentId] " + documentId);
        return function(dispatch) {
            return Rest.downloadFileStreamGET('armCoreQuest/downloadDoc?documentId=' + documentId, dispatch).then(
                resolve => {
                    console.log("[AppActions]  download [documentId] " + documentId) + " resolve";
                }, reject => {
                    console.log("[AppActions]  download [documentId] " + documentId) + " reject";
                });
        }
    }

    downloadDocument(path) {
        console.log("[AppActions]  download [path] " + path);
        return function(dispatch) {
            return Rest.downloadFileStreamPOST(path, dispatch).then(
                resolve => {
                    console.log("[AppActions]  download [path] " + path) + " resolve";
                }, reject => {
                    console.log("[AppActions]  download [path] " + path) + " reject";
                });
        }
    }

    saveI18NlabelsMancanti() {
        let that = this;
        return function(dispatch, getState) {
            let pojoList = getState().app.i18nlabelsMancanti;
            return Rest.post('i18n/saveI18NList', pojoList, dispatch).then(
                resolve => {
                    console.log("Tutte le label aggiunte");
                    dispatch(that.addNotify('SUCCESS', 'Le labels mancanti sono state aggiunte con successo'));
                    return resolve;
                },
                reject => {
                    return reject;
                }
            )
        }
    }

}

export default AppActions = new AppActions;